import { dataExplorerSlice } from './dataExplorer.slice';

export const DATA_EXPLORER_REDUCER_KEY = dataExplorerSlice.name;
export const dataExplorerReducer = dataExplorerSlice.reducer;
